import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { CcReviewReviewType } from "server/models"
import { StoreType, addModal } from "client/store"
import {
    Link,
    TableColumn,
} from "client/components"

import Edit from "./edit"

const Columns = (
    editAccess: boolean,
) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
        },
        {
            field: "name",
            header: lang.name,
            cellMinWidth: "100px",
            formatter: (type: CcReviewReviewType) => (
                <Link
                    href="/#"
                    onClick={() => dispatch(addModal({
                        key: "editType",
                        content: <Edit typeId={type.id} editAccess={editAccess} />,
                    }))}
                >
                    {type.name}
                </Link>
            ),
        },
    ]

    if (editAccess) {
        columns.unshift({
            field: "sort",
            centerAlign: true,
        })
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
